import { toE164, formatPhone } from './phone';
import { entriesOf } from './contactMethods';
import { toCsv } from './contactCsv';

// BL-177 PR D4: CSV export of the signed-in person's OWN My Contacts. Parsing / column mapping / row building on the way IN is PR C's
// (src/lib/contactCsv.js); only the shape of the rows going OUT differs (a My Contact has a company NAME, not an account).

/** One row per My Contact, labeled phones / emails / addresses with the Primary flagged (same column pattern as the company export). */
export function buildPersonalExportCsv(contacts) {
    const list = contacts || [];
    const most = (kind) => Math.max(1, ...list.map(contact => entriesOf(contact, kind).filter(e => (e.value || '').trim()).length));
    const phoneCount = most('phone'); const emailCount = most('email'); const addressCount = most('address');
    const headers = ['Name', 'Company', 'Title', 'Tags', 'Notes', 'Source', 'Created', 'Updated'];
    for (let i = 1; i <= phoneCount; i += 1) headers.push(`Phone ${i} label`, `Phone ${i} E.164`, `Phone ${i} formatted`, `Phone ${i} primary`);
    for (let i = 1; i <= emailCount; i += 1) headers.push(`Email ${i} label`, `Email ${i}`, `Email ${i} primary`);
    for (let i = 1; i <= addressCount; i += 1) headers.push(`Address ${i} label`, `Address ${i}`, `Address ${i} primary`);
    const rows = list.map((contact) => {
        const row = [contact.name || '', contact.company_name || '', contact.position || '', (contact.tags || []).join('; '),
            contact.notes || '', contact.source || '', contact.created_at || '', contact.updated_at || ''];
        const phones = entriesOf(contact, 'phone').filter(e => (e.value || '').trim());
        const emails = entriesOf(contact, 'email').filter(e => (e.value || '').trim());
        const addresses = entriesOf(contact, 'address').filter(e => (e.value || '').trim());
        for (let i = 0; i < phoneCount; i += 1) {
            const e = phones[i];
            row.push(e?.label || '', e ? (toE164(e.value, 'US') || e.value) : '', e ? formatPhone(e.value) : '', e ? (e.is_primary ? 'Yes' : 'No') : '');
        }
        for (let i = 0; i < emailCount; i += 1) { const e = emails[i]; row.push(e?.label || '', e?.value || '', e ? (e.is_primary ? 'Yes' : 'No') : ''); }
        for (let i = 0; i < addressCount; i += 1) { const e = addresses[i]; row.push(e?.label || '', e?.value || '', e ? (e.is_primary ? 'Yes' : 'No') : ''); }
        return row;
    });
    return toCsv(headers, rows);
}
